export default __webpack_public_path__ + "static/media/error.849f8a7d.jpg";